import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import SiteJsonUnits from './SiteJsonUnits';
import SiteJsonOutside360 from './SiteJsonOutside360';
import HouseTypes from './HouseTypes';
import FiltersSettings from '../filters/FiltersSettings';
import SiteJsonBirdsEyeViews from './SiteJsonBirdsEyeViews';
import CurrencyConfiguration from '../configuration/CurrencyConfiguration';
import Models from '../modelling/Models';
import exposeBinding from '../mvvm/exposeBinding';
import WhenFinishedModifying from '../core/WhenFinishedModifying';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJson{
	constructor(props){
		enableAcceptBindings(this);
		const {birdsEyeViews, units, houseTypes, filtersSettings,
		outside360, currencyConfiguration, models, configuration,
		latLng}=props;
		this._latLng = latLng;
		this._configuration = configuration;
		if(!units)throwNotProvided('units');
		this._units = units;
		if(!houseTypes)throwNotProvided('houseTypes');
		this._houseTypes = houseTypes;
		if(!filtersSettings)throwNotProvided('filtersSettings');
		this._filtersSettings = filtersSettings;
		if(!birdsEyeViews)throwNotProvided('birdsEyeViews');
		this._birdsEyeViews = birdsEyeViews;
		//if(!outside360)throwNotProvided('outside360');
		this._outside360 = outside360;
		if(!currencyConfiguration)throwNotProvided('currencyConfiguration');
		this._currencyConfiguration = currencyConfiguration;
		this._models = models;
		this.getPlotsForHouseType = this.getPlotsForHouseType.bind(this);
		this.getPlotByNumber= this.getPlotByNumber.bind(this);
		this.getPlotsArray= this.getPlotsArray.bind(this);
		this._houseTypesOrPlotFeaturesChanged = this._houseTypesOrPlotFeaturesChanged.bind(this);
		this._updateAllFeatures = this._updateAllFeatures.bind(this);
		this._whenFinishedModifyingHouseTypesOrPlotFeatures = new WhenFinishedModifying({
			delay:0.1, callback:this._updateAllFeatures
		});
		houseTypes.getArray().forEach(houseType=>houseType.addEventListener('featureschanged', this._houseTypesOrPlotFeaturesChanged));
		this.getPlotsArray().forEach(siteJsonUnitPlot=>siteJsonUnitPlot.addEventListener('plotfeatureschanged', this._houseTypesOrPlotFeaturesChanged));
		exposeBinding(this, 'allFeatures', ()=>this.allFeatures, (value)=>this.allFeatures = value);
	}
	get allUnitsHaveMultiplePlots(){
		for(var unit of this._units.getArray())
			if(unit.plots.length<2)return false;
		return true;
	}
	get latLng(){
		return this._latLng;
	}
	get configuration(){
		return this._configuration;
	}
	get name(){
		throwNotProvided('name');
	}
	get currencyConfiguration(){
		return this._currencyConfiguration;
	}
	get outside360(){
		return this._outside360;
	}
	get units(){
		return this._units;
	}
	get filtersSettings(){
		return this._filtersSettings;
	}
	get birdsEyeViews(){
		return this._birdsEyeViews;
	}
	get houseTypes(){
		return this._houseTypes;
	}
	get allFeatures(){
		return this._allFeatures;
	}
	get models(){
		return this._models;
	}
	getPlotByNumber(plotNumber){
		return this.units.getPlotByNumber(plotNumber);
	}
	getPlotsArray(plotNumber){
		return this.units.getPlotsArray();
	}
	getPlotsForHouseType(houseType){
		return this.getPlotsArray().filter(plot=>plot.houseType===houseType);
	}
	get minPlotPrice(){
		let min = null;
		this.getPlotsArray().forEach(siteJsonUnitPlot=>{
			if(siteJsonUnitPlot.price===0||siteJsonUnitPlot.price===null||siteJsonUnitPlot.price===undefined) return;
			if(min===null)
				min = siteJsonUnitPlot.price;
			else 
				if(min>siteJsonUnitPlot.price)
					min = siteJsonUnitPlot.price;
		});
		return min;
	}
	get maxPlotPrice(){
		let max = null;
		this.getPlotsArray().forEach(siteJsonUnitPlot=>{
			if(max===null)
				max = siteJsonUnitPlot.price;
			else 
				if(max<siteJsonUnitPlot.price)
					max = siteJsonUnitPlot.price;
		});
		return max;
	}
	_houseTypesOrPlotFeaturesChanged(){
		this._whenFinishedModifyingHouseTypesOrPlotFeatures.trigger();
	}
	_updateAllFeatures(){
		const mapFeatureIdToFeature = new Map();
		this.getPlotsArray().forEach(siteJsonUnitPlot=>{
			siteJsonUnitPlot.features?.forEach(feature=>{
				mapFeatureIdToFeature.set(feature.id, feature);
			});
		});
		this.houseTypes.getArray().forEach(houseType=>{
			houseType.features?.forEach(feature=>{
				mapFeatureIdToFeature.set(feature.id, feature);
			});
		});
		this._allFeatures = Array.from(mapFeatureIdToFeature.values());
		this.bindingsHandler.changed('allFeatures', this._allFeatures);
	}
	static fromJSON(jObjectSite, configuration){
		const name = jObjectSite.name;
		let siteJson = null;
		const houseTypes = HouseTypes.fromJSON(jObjectSite.houseTypes,
			()=>siteJson, configuration);
		const currencyConfiguration = CurrencyConfiguration.fromJSON(jObjectSite.configuration.currency);
		const units = SiteJsonUnits.fromJSON(jObjectSite.units, houseTypes, currencyConfiguration);
		const filtersSettings = FiltersSettings.fromJSON(jObjectSite.filtersSettings);
		const outside360 = jObjectSite.outside360?SiteJsonOutside360.fromJSON(jObjectSite.outside360,
		(plotNumber)=>units.getPlotByNumber(plotNumber), configuration):null;
		const birdsEyeViews = SiteJsonBirdsEyeViews.fromJSON(jObjectSite.birdsEyeViews, configuration);
		const models = jObjectSite.models?Models.fromJSON(jObjectSite.models):null;
		siteJson =  new SiteJson({
			name:name, birdsEyeViews:birdsEyeViews,units:units, houseTypes:houseTypes, filtersSettings:filtersSettings, outside360:outside360,
			currencyConfiguration:currencyConfiguration, models:models,
			configuration,
			latLng:jObjectSite.latLng
		});
		return siteJson;
	}
}